import React, { useState } from "react";
import { useWeb3 } from "../context/Web3Context";
import { useToast } from "./common/Toast";
import { useTx } from "../context/TxContext";
import { getPurchaseContract } from "../web3/contracts";
import { addScnToWallet } from "../web3/addToken";
import { parseError } from "../utils/errors";
import { fmtScn, fmtUsdt } from "../utils/format";
import Button from "./common/Button";
import Confetti from "./common/Confetti";

// SCN claim lives on the SmartcoreNodePurchase contract (claimSCN()).
// scnStats: getUserSCNStats tuple [claimable, totalClaimed]
export default function ClaimSCN({ scnStats, scnBal, scnPrice, onDone }) {
  const { signer } = useWeb3();
  const toast = useToast();
  const { run } = useTx();
  const [burst, setBurst] = useState(0);

  const claimable = scnStats ? scnStats.claimable : null;
  const claimed = scnStats ? scnStats.totalClaimed : null;
  const nothing = !claimable || claimable.isZero();

  const onClaim = async () => {
    if (!signer) return;
    try {
      await run("Claiming SCN", async () => {
        const purchase = getPurchaseContract(signer);
        const tx = await purchase.claimSCN();
        await tx.wait();
      });
      setBurst(Date.now());
      toast.success("SCN claimed to your wallet.");
      onDone && onDone();
    } catch (e) {
      toast.error(parseError(e));
    }
  };

  const onAddToken = async () => {
    try {
      const added = await addScnToWallet();
      if (added) toast.success("SCN token added to your wallet.");
      else toast.info("Import cancelled.");
    } catch (e) {
      toast.error(parseError(e));
    }
  };

  return (
    <div className="card fade-up">
      {burst > 0 && <Confetti key={burst} />}
      <h2 className="card-title">SmartCore Node Fraction Token</h2>
      <div className="grid grid-3">
        <div className="stat">
          <div className="label">Claimable SCN</div>
          <div className="value glow">{fmtScn(claimable)}</div>
        </div>
        <div className="stat">
          <div className="label">Wallet SCN</div>
          <div className="value">{fmtScn(scnBal)}</div>
        </div>
        <div className="stat">
          <div className="label">SCN Price</div>
          <div className="value">${fmtUsdt(scnPrice, 2)}</div>
        </div>
      </div>

      <div className="row between mt-4" style={{ fontSize: 14 }}>
        <span className="muted">Total claimed so far</span>
        <span>{fmtScn(claimed)} SCN</span>
      </div>

      <div className="mt-4">
        <Button variant="success" className="btn-block" onClick={onClaim} disabled={nothing}>
          {nothing ? "No SCN to claim" : "Claim SCN"}
        </Button>
      </div>

      <button className="btn btn-secondary btn-block mt-3 add-token-btn" onClick={onAddToken}>
        <span className="add-token-ico">＋</span> Add SCN to your wallet
      </button>
    </div>
  );
}
